module.exports = __webpack_public_path__ + "img/schema-coeur-orly.c7ef505e.jpg";